import React, { Fragment } from 'react'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TabPanel from '@mui/lab/TabPanel';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import DocumentacionGeneralComponent from './DocumentacionGeneralComponent'
import DocumentacionDomiciliosComponent from './DocumentacionDomiciliosComponent'
import DocumentacionPrediosComponent from './DocumentacionPrediosComponent'
import DocumentacionViverosComponent from './DocumentacionViverosComponent'
import DocumentacionInstalacionesComponent from './DocumentacionInstalacionesComponent'
import DocumentacionMarcasMezcalComponent from './DocumentacionMarcasMezcalComponent'
import DocumentacionMarcasBebidasMezcalComponent from './DocumentacionMarcasBebidasMezcalComponent'
import OficiosComponent from './OficiosComponent'

function DocumentacionComponent(props) {

    let detalleCliente = props?.detalle

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`vertical-tabpanel-${index}`}
                aria-labelledby={`vertical-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box sx={{ p: 3 }}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `vertical-tab-${index}`,
            'aria-controls': `vertical-tabpanel-${index}`,
        };
    }

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box
            sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', height: 800, boxShadow: '0 0px 16px 0px rgba(0, 0, 0, 0.3)', borderRadius: '8px' }}
        >
            <Tabs
                orientation="vertical"
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="Vertical tabs example"
                TabIndicatorProps={{ style: { backgroundColor: '#7D9A47' } }}
                sx={{ borderRight: 1, borderColor: 'divider', width: '20%',
                    "& button": { color: '#7D9A47', fontFamily: 'Montserrat', fontWeight: 'bold', textAlign: 'left'},
                    "& button:hover": { color: '#7D9A47', transform: 'scale(1.1)' },
                    "& button.Mui-selected": { backgroundColor: 'rgba(125, 154, 71, 0.3)', color: '#7D9A47' },
                    "&& .MuiTab-root": { alignItems: 'baseline' },
                }}
            >
                <Tab label="General" {...a11yProps(0)} />
                <Tab label="Domicilios" {...a11yProps(1)} />
                <Tab label="Predios" {...a11yProps(2)} />
                <Tab label="Viveros" {...a11yProps(3)} />
                <Tab label="Instalaciones" {...a11yProps(4)} />
                <Tab label="Marcas de mezcal" {...a11yProps(5)} />
                <Tab label="Marcas de bebidas con mezcal" {...a11yProps(6)} />
                <Tab label="Oficios" {...a11yProps(7)} />
            </Tabs>
            <TabPanel value={value} index={0} style={{ width: '80%' }}>
                <DocumentacionGeneralComponent detalle={detalleCliente}/>
            </TabPanel>
            <TabPanel value={value} index={1} style={{ width: '80%' }}>
                <DocumentacionDomiciliosComponent detalle={detalleCliente}/>
            </TabPanel>
            <TabPanel value={value} index={2} style={{ width: '80%' }}>
                <DocumentacionPrediosComponent detalle={detalleCliente}/>
            </TabPanel>
            <TabPanel value={value} index={3} style={{ width: '80%' }}>
                <DocumentacionViverosComponent detalle={detalleCliente}/>
            </TabPanel>
            <TabPanel value={value} index={4} style={{ width: '80%' }}>
                <DocumentacionInstalacionesComponent detalle={detalleCliente}/>
            </TabPanel>
            <TabPanel value={value} index={5} style={{ width: '80%' }}>
                <DocumentacionMarcasMezcalComponent detalle={detalleCliente}/>
            </TabPanel>
            <TabPanel value={value} index={6} style={{ width: '80%' }}>
                <DocumentacionMarcasBebidasMezcalComponent detalle={detalleCliente}/>
            </TabPanel>
            <TabPanel value={value} index={7} style={{ width: '80%' }}>
                <OficiosComponent detalle={detalleCliente}/>
            </TabPanel>
        </Box>
    );

}



export default DocumentacionComponent